
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class MailboxModel extends Model<MailboxModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', languageString: 'mailbox.property.id', isHidden: true },
		{ name: 'principalName', type: 'string', languageString: 'mailbox.property.principalName' },
		{ name: 'displayName', type: 'string', languageString: 'mailbox.property.displayName' },
		{ name: 'aliases', type: 'string[]', languageString: 'mailbox.property.aliases', isArray: true },
		{ name: 'licenses', type: 'string[]', languageString: 'mailbox.property.licenses', isArray: true }
	];
	[key: string]: any;
	
	public id: string;
	public principalName: string;
	public displayName: string;
	public aliases: string[];
	public licenses: string[];
    
	constructor(){
		super();
		this.id = '';
		this.principalName = '';
		this.displayName = '';
		this.aliases = [];
		this.licenses = [];
		
	}
	getProperties(){
		return MailboxModel.classProperties;
	}
}

